import { useEffect, useRef, useState } from 'react';
import { useAppSelector } from 'shared/lib';

export const useCaptchaLoaded = () => {
  const MAX_ATTEMPTS = 3;
  const RETRY_DELAY = 5000;

  const [isLoaded, setIsLoaded] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const loadedTimeoutRef = useRef<ReturnType<typeof setTimeout>>();

  const { isCaptchaNeed } = useAppSelector(
    (state) => state.yaSmartCaptchaReducer,
  );

  useEffect(() => {
    const checkCaptcha = () => {
      if (window.smartCaptcha) {
        localStorage.removeItem('captcha_attempts');
        setErrorMessage('');
        setIsLoaded(true);
        return true;
      }
      return false;
    };

    const tryLoadCaptcha = () => {
      const attempts = Number(localStorage.getItem('captcha_attempts')) || 0;

      if (checkCaptcha()) return;

      if (attempts >= MAX_ATTEMPTS) {
        console.error('Не удалось загрузить каптчу после нескольких попыток');
        setErrorMessage(
          'Не удалось загрузить каптчу после нескольких попыток... Попробуйте перезагрузить страницу',
        );
        return;
      }

      loadedTimeoutRef.current = setTimeout(() => {
        if (!checkCaptcha()) {
          localStorage.setItem('captcha_attempts', (attempts + 1).toString());
          clearTimeout(loadedTimeoutRef.current);
          window.location.reload();
        }
      }, RETRY_DELAY);
    };

    if (isCaptchaNeed) {
      if (checkCaptcha()) return;

      const interval = setInterval(() => {
        if (checkCaptcha()) {
          clearInterval(interval);
        }
      }, 300);

      tryLoadCaptcha();
      return () => {
        clearTimeout(loadedTimeoutRef.current);
        clearInterval(interval);
      };
    }
  }, [isCaptchaNeed]);

  return { isLoaded, errorMessage };
};
